import { api } from './api';
import { Position, ApiResponse } from '../types';

interface PositionQueryOptions {
  activeOnly?: boolean;
}

export const getPositions = async (options: PositionQueryOptions = {}): Promise<Position[]> => {
  try {
    const params = new URLSearchParams();
    if (options.activeOnly) {
      params.append('activeOnly', 'true');
    }

    const response = await api.get(`/positions${params.toString() ? `?${params.toString()}` : ''}`);
    return response.data.data;
  } catch (error) {
    console.error('Failed to fetch positions:', error);
    throw error;
  }
};

export const getPosition = async (id: string): Promise<Position> => {
  try {
    const response = await api.get(`/positions/${id}`);
    return response.data.data;
  } catch (error) {
    console.error(`Failed to fetch position ${id}:`, error);
    throw error;
  }
};

export const createPosition = async (positionData: Partial<Position>): Promise<Position> => {
  try {
    const response = await api.post('/positions', positionData);
    return response.data.data;
  } catch (error) {
    console.error('Failed to create position:', error);
    throw error;
  }
};

export const updatePosition = async (id: string, positionData: Partial<Position>): Promise<Position> => {
  try {
    const response = await api.put(`/positions/${id}`, positionData);
    return response.data.data;
  } catch (error) {
    console.error(`Failed to update position ${id}:`, error);
    throw error;
  }
};

export const deletePosition = async (id: string): Promise<void> => {
  try {
    await api.delete(`/positions/${id}`);
  } catch (error) {
    console.error(`Failed to delete position ${id}:`, error);
    throw error;
  }
};